module.exports = __webpack_public_path__ + "img/aktuelles_adventsfenster2022.7c5f3bb6.jpg";